<template>
  <screen
    can-skip
    :screen-name="$t('stamp.choose_to_start.title')"
    :screen-info="info"
    :show-intro.sync="showIntro"
    :intro-duration="4"
    :error="error"
    @skip="leave"
  >
    <feet-mark v-show="showFeet" />
    <doll
      v-show="!showFeet"
      :show-clench-hint.sync="showClenchHint"
      :clench-hint-duration="4.5"
      :left="left"
      :right="right"
      :left-range="leftRange"
      :right-range="rightRange"
      :left-breathing="breathing"
      :right-breathing="breathing"
      @left-hit="handleLeftHit"
      @right-hit="handleRightHit"
    />
  </screen>
</template>

<script>
import stampBgm from '@/mixins/stamp-bgm';
import autoClearTimer from '@/mixins/auto-clear-timer';
import audioPlayer from '@/mixins/audio-player';
import handleArmDetection from '@/mixins/arm-detection';
import leave from '@/mixins/leave';
import { wait } from '@/modules/utils';
import i18n from '../../i18n';
import Screen from '../../components/Stamp/Screen.vue';
import Doll from '../../components/Stamp/Doll.vue';
import FeetMark from '../../components/Stamp/FeetMark.vue';

export default {
  name: 'ChooseToStart',
  components: {
    Screen,
    Doll,
    FeetMark,
  },
  mixins: [autoClearTimer, handleArmDetection, stampBgm, audioPlayer, leave],
  mounted() {
    this.toggleArmMotionListening(false);
    this.startArmDetection();
    this.playAudio('v13_7');
  },
  data: () => ({
    info: i18n.t('stamp.feet_position'),
    breathing: true,
    showIntro: true,
    showClenchHint: false,
    showFeet: false,
    error: false,
  }),
  methods: {
    showError() {
      this.error = true;
      this.info = i18n.t('stamp.choose_to_start.start');
    },
    startScan() {
      this.$events.goto('StampScanBody');
    },
  },
  computed: {
    bothReady() {
      return this.leftReady && this.rightReady;
    },
  },
  watch: {
    showIntro(nv, ov) {
      if (!nv && ov) {
        this.showFeet = true;
        this.info = i18n.t('stamp.feet_position');
        this.playAudio('v13_8').then(() => {
          this.showFeet = false;
        });
      }
    },
    showFeet(nv, ov) {
      if (!nv && ov) {
        this.info = i18n.t('stamp.clench');
        this.showClenchHint = true;
      }
    },
    showClenchHint(nv, ov) {
      if (!nv && ov) {
        this.toggleArmMotionListening(true);
        this.info = i18n.t('stamp.choose_to_start.start');
        this.playAudio('Voice5')
          .then(() => wait(1))
          .then(() => {
            if (!this.somethingHit) {
              this.showError();
            }
          });
      }
    },
    error(nv) {
      if (nv) {
        this.playNegative();
      }
    },
    somethingHit(nv) {
      if (nv) {
        this.breathing = false;
        this.error = false;
      } else {
        this.showError();
      }
    },
    bothReady(nv) {
      if (nv) {
        this.info = i18n.t('stamp.choose_to_start.done');
        this.playPositive();
        setTimeout(() => {
          this.startScan();
        }, 500);
      }
    },
  },
};
</script>
